/**
 * @module wdh-geo-ip-prompt
 */

import WDHGeoIpPrompt from './src/js/wdh-geo-ip-prompt';
export { WDHGeoIpPrompt };